import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "../button";
import Header from "../header";
import onClickOutside from "react-onclickoutside";
import * as CONSTANTS from "./constants";
import * as CONSTANTS_BUTTONS from "../button/constants";
// import {v4 as uuidv4} from 'uuid' // random

class ModalContent extends React.Component {
  // eslint-disable-next-line
  handleClickOutside = () => {
    if (!this.props.noCloseOnClickOutside) {
      this.props.noHandlerOnClick();
    }
  };

  render() {
    const modalContentClasses = classNames(
      "modal-content",
      {
        [`width-${this.props.width}`]: this.props.width,
        [`height-${this.props.height}`]: this.props.height
      },
      this.props.classNameContent
    );
    const modalHeaderClasses = classNames(
      "modal-header",
      this.props.classNameHeader
    );
    const modalBodyClasses = classNames("modal-body", this.props.classNameBody);
    const modalFooterClasses = classNames(
      "modal-footer",
      this.props.classNameFooter
    );

    let headerContent = null;
    if (this.props.title) {
      headerContent = (
        <div className={modalHeaderClasses}>
          <Header size={4} margin="no" className="title">
            {this.props.title}
          </Header>

          <Button
            className="close"
            size="s"
            theme="white-primary"
            onClick={this.props.noHandlerOnClick}
          >
            X
          </Button>
        </div>
      );
    }

    let footerContent = null;

    if (this.props.type === CONSTANTS.YES_NO) {
      footerContent = (
        <div className={modalFooterClasses}>
          <Button
            theme={this.props.yesThemeButton}
            onClick={this.props.yesHandlerOnClick}
            disabled={this.props.yesDisabled}
          >
            {this.props.yesTitle}
          </Button>
          <Button
            theme={this.props.noThemeButton}
            onClick={this.props.noHandlerOnClick}
          >
            {this.props.noTitle}
          </Button>
        </div>
      );
    } else if (this.props.footer) {
      footerContent = (
        <div className={modalFooterClasses}>{this.props.footer}</div>
      );
    }

    return (
      <div className={modalContentClasses}>
        {headerContent}

        <div className={modalBodyClasses}>{this.props.children}</div>

        {footerContent}
      </div>
    );
  }
}

ModalContent.defaultProps = {
  type: CONSTANTS.YES_NO,
  title: null,
  footer: null,
  noCloseOnClickOutside: false,

  width: null,
  height: null,
  classNameContent: null,
  classNameHeader: null,
  classNameBody: null,
  classNameFooter: null,
  yesHandlerOnClick: () => {
    return false;
  },
  noHandlerOnClick: () => {
    return false;
  },
  yesTitle: "Подтвердить",
  noTitle: "Отменить",
  yesThemeButton: "primary",
  noThemeButton: "default",
  yesDisabled: false,
  children: null
};

ModalContent.propTypes = {
  type: PropTypes.oneOf([CONSTANTS.YES_NO, CONSTANTS.ALERT]),
  title: PropTypes.string,
  footer: PropTypes.node,
  noCloseOnClickOutside: PropTypes.bool,

  width: PropTypes.oneOf(["normal", "xs", "sm", "md", "lg", "full"]),
  height: PropTypes.oneOf(["full"]),
  classNameContent: PropTypes.oneOfType(PropTypes.string, PropTypes.object),
  classNameHeader: PropTypes.oneOfType(PropTypes.string, PropTypes.object),
  classNameBody: PropTypes.oneOfType(PropTypes.string, PropTypes.object),
  classNameFooter: PropTypes.oneOfType(PropTypes.string, PropTypes.object),

  yesTitle: PropTypes.string,
  yesHandlerOnClick: PropTypes.func,
  yesThemeButton: PropTypes.oneOf(CONSTANTS_BUTTONS.THEME),
  yesDisabled: PropTypes.bool,

  noTitle: PropTypes.string,
  noHandlerOnClick: PropTypes.func,
  noThemeButton: PropTypes.oneOf(CONSTANTS_BUTTONS.THEME),

  children: PropTypes.node
};

export default onClickOutside(ModalContent);
